export default function fadeOut(element, callBack) {
    element.classList.remove("animateFadeIn");
    element.classList.add("animateFadeOut");
    setTimeout(() => {
        element.classList.add("hide");
        if(callBack) callBack();
    }, 400);
}